<template>
  <div>
    <form
      id="project-form"
      @submit="checkForm"
      action="#"
      method="post"
      novalidate="true"
    >
      <div class="form-item">
        <label class="required" for="project-name">{{
          $t("project.projectEditForm.projectName")
        }}</label>
        <p v-if="errProjectName && projectName.length > 30" class="error">
          {{ $t("project.projectEditForm.errorMsg.projectName") }}
        </p>
        <p v-if="errSurrogatePair" class="error">
          {{ $t("project.projectEditForm.errorMsg.surrogatePair") }}
        </p>
        <input
          id="project-name"
          name="project-name"
          maxlength="30"
          v-model="projectName"
          v-on:input="
            updateForm = true;
            errProjectName = false;
            errSurrogatePair = false;
            invalidProjectName = false;
          "
          v-bind:class="{
            error: errProjectName || errSurrogatePair || invalidProjectName,
          }"
        />
        <p v-if="errProjectName" class="error errorMsg">
          {{ $t("project.projectEditForm.errorMsg.noProjectName") }}
        </p>
        <p v-if="invalidProjectName" class="error errorMsg">
          {{ $t("project.projectEditForm.errorMsg.invalidProjectName") }}
        </p>
        <span
          v-bind:class="{ 'char-count': true, error: projectName.length > 300 }"
        >
          {{ projectName.length }} / 30
        </span>
      </div>

      <div class="form-item">
        <label class="" for="project-summary">{{
          $t("project.projectEditForm.projectSummary")
        }}</label>
        <p
          v-if="errProjectSummary && projectSummary.length > 300"
          class="error"
        >
          {{ $t("project.projectEditForm.errorMsg.projectSummary") }}
        </p>
        <textarea
          id="project-summary"
          name="project-summary"
          rows="4"
          maxlength="300"
          v-model="projectSummary"
          v-on:input="updateForm = true"
          v-bind:class="{ error: errProjectSummary }"
        ></textarea>
        <span
          v-bind:class="{
            'char-count': true,
            error: projectSummary.length > 300,
          }"
        >
          {{ projectSummary.length }} / 300
        </span>
      </div>

      <div
        v-if="
          user.userInfo &&
            (role === 'Owner' ||
              role === 'PlanOwner' ||
              user.userInfo.userType === 1)
        "
        class="archive-wrapper"
      >
        <input
          type="checkbox"
          id="archive"
          v-model="projectArchived"
          v-on:input="updateForm = true"
        />
        <label for="archive">{{ $t("project.projectEditForm.archive") }}</label>
      </div>

      <input
        type="submit"
        class="submit"
        v-bind:value="$t('project.projectEditForm.button.save')"
      />
    </form>
    <Modal
      v-if="showModal"
      v-bind:modalTitle="$t('project.projectEditForm.modal.header')"
      @close="showModal = false"
    >
      <div class="confirm-modal">
        <p>
          <strong>{{ $t("project.projectEditForm.modal.text") }}</strong>
        </p>
        <a v-on:click.prevent="updateProject" class="button" href="#">OK</a>
        <a
          v-on:click="showModal = false"
          class="button archive-cancel"
          href="#"
          >{{ $t("project.projectEditForm.button.cancel") }}</a
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/Modal.vue";

import { validSurrogatePair } from "@/utils/validSurrogatePair";
import { validFileInclusion } from "@/utils/validFileInclusion";
import { groupService } from "@/services/group.service";
import { projectService } from "@/services/project.service";

export default {
  name: "ProjectForm",
  components: {
    Modal,
  },
  data() {
    return {
      user: {},
      role: "",

      projectId: 0,
      invalidForm: true,
      invalidProjectName: false,

      errProjectName: false,
      errSurrogatePair: false,
      errProjectSummary: false,

      projectName: "",
      projectSummary: "",
      projectArchived: false,

      showModal: false,
    };
  },
  mounted: function() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.projectId = this.$route.params.projectId;

    this.fetchProject();
  },
  methods: {
    fetchGroup: function(groupId) {
      // grab the group
      groupService.getGroup(groupId).then((group) => {
        this.role = group.role;
      });
    },
    checkForm: function(event) {
      this.invalidForm = false;
      this.errProjectName = false;
      this.errSurrogatePair = false;
      this.errProjectSummary = false;

      if (this.projectName === "") {
        this.invalidForm = true;
        this.errProjectName = true;
      }

      if (
        this.projectName.length > 30 ||
        validFileInclusion(this.projectName)
      ) {
        this.invalidForm = true;
        this.invalidProjectName = true;
      }

      if (validSurrogatePair(this.projectName)) {
        this.invalidForm = true;
        this.errSurrogatePair = true;
      }

      if (this.projectSummary.length > 300) {
        this.invalidForm = true;
        this.errProjectSummary = true;
      }

      if (!this.invalidForm) {
        if (this.projectArchived) {
          this.showModal = true;
        } else {
          this.updateProject();
        }
      }

      event.preventDefault();
    },
    fetchProject: function() {
      projectService
        .getProject(this.projectId)
        .then((project) => {
          this.projectName = project.name;
          if (project.description) {
            this.projectSummary = decodeURIComponent(atob(project.description));
          }
          this.projectArchived = !project.enabled;

          this.fetchGroup(project.groupId);
        })
        .catch((err) => {
          console.error("Error fetching project: ", err);
        });
    },
    updateProject: function() {
      let modProject = {
        description: btoa(encodeURIComponent(this.projectSummary)),
        name: this.projectName,
        enabled: !this.projectArchived,
      };

      projectService
        .updateProject(this.projectId, modProject)
        .then(() => {
          this.confirmArchive();
        })
        .catch((err) => {
          console.error("Something went wrong updating project: ", err);
        });
    },
    confirmArchive: function() {
      this.showModal = false;
      this.$router.push("/project/" + this.projectId);
    },
  },
};
</script>
<style lang="scss">
.modal-body {
  color: $text-dark;
  padding: 40px 40px 0;

  #project-form {
    padding: 20px 0;
  }
}

#project-form {
  max-width: 528px;

  .form-item {
    position: relative;
    .char-count {
      position: absolute;
      right: 0;
      bottom: 5px;
    }
  }

  .archive-wrapper {
    margin-bottom: 25px;

    label {
      display: inline;
    }
  }

  input.submit {
    @extend button;
    margin-top: 0;
    width: auto;
  }
  .auth-req {
    margin-top: 15px;
    padding-top: 30px;
    border-top: 2px solid #ccc;
  }
}

.confirm-modal {
  padding: 0 0 25px 0;
}

.archive-cancel {
  margin-left: 50px;
}
</style>
